module.exports = __webpack_public_path__ + "static/media/cwaitChecked.1cd3eb5b.svg";